import { useCallback, useEffect, useRef, useState } from "react";

export const useColumnSize = () => {
    const colRef = useRef();
    const resizerRef = useRef();
    const colSizeRef = useRef(0);
    const initialPosRef = useRef(0);
    const mousePosRef = useRef(0);
    const [width, setWidth] = useState(0);

    const resize = useCallback((e) => {
        const newWidth = mousePosRef.current + e.clientX - initialPosRef.current;

        if (resizerRef.current) {
            const rightPos = e.clientX - initialPosRef.current;
            resizerRef.current.style.right = `${-rightPos}px`;

            colSizeRef.current = newWidth;
        }
    }, []);

    useEffect(() => {
        return () => {
            document.removeEventListener("mouseup", resize, false);
            document.removeEventListener("mousemove", resize, false);
        };
    }, [resize]);

    const onMouseUp = useCallback((e) => {
        e.stopPropagation();
        setWidth(colSizeRef.current);

        if (resizerRef.current) {
            resizerRef.current.style.right = 0;
        }

        document.removeEventListener("mousemove", resize, false);
    }, [resize]);

    const initialize = useCallback((e) => {
        initialPosRef.current = e.clientX;
        mousePosRef.current = colRef.current.offsetWidth;

        document.addEventListener("mousemove", resize, false);
        document.addEventListener("mouseup", onMouseUp, false);
    }, [onMouseUp, resize]);

    return { colRef, resizerRef, width, initialize };
};
